import { apiClient } from './client';
import type { StateInfo } from '../types';

export interface StatusConfig {
  anfrage: StateInfo[];
  inserat: StateInfo[];
  verfahren: StateInfo[];
}

export interface AssignmentDefaults {
  verfahren: number | null;
  anfrage: number | null;
  inserat: number | null;
  adresse: number | null;
}

/** Per-city module master switches, keyed by module (missing key → enabled). */
export type ModuleVisibility = Record<string, boolean>;
/** Per-city overview column visibility: {list_key: {column_key: bool}}. */
export type ColumnConfig = Record<string, Record<string, boolean>>;
/** Per-city documents feature config: {entity: {tab/upload/create: bool}}. */
export type DocumentConfig = Record<string, { tab: boolean; upload: boolean; create: boolean }>;

export interface TaskTemplate {
  title: string;
  frist_tage?: number | null;
}
/** {entity_type: {status_key: TaskTemplate[]}} */
export type StatusTaskTemplates = Record<string, Record<string, TaskTemplate[]>>;

export const configApi = {
  getStatusConfig: async (): Promise<StatusConfig> => {
    const { data } = await apiClient.get('/config/status');
    return data;
  },

  updateAccountStatusConfig: async (userId: number, config: Partial<StatusConfig>): Promise<StatusConfig> => {
    const { data } = await apiClient.put(`/admin/accounts/${userId}/status-config`, config);
    return data;
  },

  getModuleVisibility: async (): Promise<ModuleVisibility> => {
    const { data } = await apiClient.get<{ modules: ModuleVisibility }>('/config/module-visibility');
    return data.modules;
  },

  getColumnConfig: async (): Promise<ColumnConfig> => {
    const { data } = await apiClient.get<{ lists: ColumnConfig }>('/config/column-config');
    return data.lists;
  },

  getDocumentConfig: async (): Promise<DocumentConfig> => {
    const { data } = await apiClient.get<{ entities: DocumentConfig }>('/config/document-config');
    return data.entities;
  },

  getAssignmentDefaults: async (): Promise<AssignmentDefaults> => {
    const { data } = await apiClient.get<AssignmentDefaults>('/config/assignment-defaults');
    return data;
  },

  updateAssignmentDefaults: async (
    defaults: Partial<AssignmentDefaults>,
  ): Promise<AssignmentDefaults> => {
    const { data } = await apiClient.put<AssignmentDefaults>(
      '/config/assignment-defaults',
      defaults,
    );
    return data;
  },

  getStatusTaskTemplates: async (): Promise<StatusTaskTemplates> => {
    const { data } = await apiClient.get<{ templates: StatusTaskTemplates }>('/config/status-task-templates');
    return data.templates;
  },

  updateStatusTaskTemplates: async (templates: StatusTaskTemplates): Promise<StatusTaskTemplates> => {
    const { data } = await apiClient.put<{ templates: StatusTaskTemplates }>(
      '/config/status-task-templates',
      { templates },
    );
    return data.templates;
  },
};
